"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiInput = void 0;
var colors_1 = require("../../generated/colors");
exports.MuiInput = {
    styleOverrides: {
        root: {
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "1px solid " + colors_1.colors.Primary,
            },
        },
        colorSecondary: {
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "1px solid " + colors_1.colors.Primary,
            },
            "&:after": {
                borderBottom: "2px solid " + colors_1.colors.Primary,
            },
        },
    },
};
//# sourceMappingURL=standard-input.js.map